import { TsDOM as q } from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import {SlideshowComponent, SlideshowFade} from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import {MediaContentToggle} from "@/scripts/theme/media-content-toggle";
import {ValueProps} from '@/scripts/theme/value-props';
import {AdvancedContentToggle} from "@/scripts/theme/advanced-content-toggle";
import {FilteredUgc} from "@/scripts/theme/filtered-ugc";
import {PressQuotes} from "@/scripts/theme/press-quotes";
import {TouchActions} from "@/scripts/theme/touch-actions";
import {MarqueeSlider} from "@/scripts/theme/marquee-slider";
import {ShadowDomWrapper} from "@/scripts/theme/shadow-dom-wrapper";
import {KlaviyoForm} from "@/scripts/theme/klaviyo-form";
import {KlaviyoPopup} from "@/scripts/theme/klaviyo-popup";
import {KlaviyoOosPopup} from "@/scripts/theme/klaviyo-oos-popup";
import {KlaviyoOosForm} from "@/scripts/theme/klaviyo-oos-form";
import { UgcSlider } from '@/scripts/theme/ugc-slider'
import { PercentGraphic } from '@/scripts/theme/percent-graphic'
import { ProductInfo } from '@/scripts/product/product-info'
import { ProductForm } from '@/scripts/product/product-form'
import { ProductModal } from '@/scripts/product/product-modal'
import { MediaGallery } from '@/scripts/product/media-gallery'
import { VariantSelects } from '@/scripts/theme/variant-selects'
import { VariantRadios } from '@/scripts/theme/variant-radios'
import { ProductRecommendations } from '@/scripts/theme/product-recommendations'
import { SellingPlan } from '@/scripts/product/selling-plan'
import { QuickAddModal } from '@/scripts/optional/quick-add'
import { ProductStickyCta } from '@/scripts/product/product-sticky-cta'
import { ShopByStyle } from "@/scripts/theme/shop-by-style";
import {PdpFloatingContaminants} from "@/scripts/theme/pdp-floating-contaminants";
import {PdpContaminantsStats} from "@/scripts/theme/pdp-contaminants-stats";
import {Tab} from "@/scripts/theme/tab";

import {ProductCard} from "@/scripts/theme/product-card";
import {MainProduct} from "@/scripts/theme/main-product";
import {CartOptionsModal} from "@/scripts/theme/cart-options-modal";
import {UpsellForm} from "@/scripts/theme/upsell-form";
q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
q.safeDefineElement(SlideshowFade)
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(MediaContentToggle)
q.safeDefineElement(ValueProps)
q.safeDefineElement(AdvancedContentToggle)
q.safeDefineElement(FilteredUgc)
q.safeDefineElement(PressQuotes)
q.safeDefineElement(TouchActions)
q.safeDefineElement(MarqueeSlider)
q.safeDefineElement(ShadowDomWrapper)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(KlaviyoPopup)
q.safeDefineElement(KlaviyoOosPopup)
q.safeDefineElement(KlaviyoOosForm)
q.safeDefineElement(UgcSlider)
q.safeDefineElement(PercentGraphic)
q.safeDefineElement(ProductInfo)
q.safeDefineElement(ProductForm)
q.safeDefineElement(ProductModal)
q.safeDefineElement(MediaGallery)
q.safeDefineElement(VariantSelects)
q.safeDefineElement(VariantRadios)
q.safeDefineElement(ProductRecommendations)
q.safeDefineElement(SellingPlan)
q.safeDefineElement(QuickAddModal)
q.safeDefineElement(CartOptionsModal)
q.safeDefineElement(UpsellForm)
q.safeDefineElement(ProductStickyCta)
q.safeDefineElement(ShopByStyle)
q.safeDefineElement(PdpFloatingContaminants)
q.safeDefineElement(PdpContaminantsStats)
q.safeDefineElement(Tab)
q.safeDefineElement(ProductCard)
q.safeDefineElement(MainProduct)
